/* eslint-disable camelcase */
jQuery( document ).ready( function ( $ ) {
	const owl_containers = document.querySelectorAll( '.owl-carousel' );

	let owl = null;

	for ( let i = 0; i < owl_containers.length; i++ ) {
		let owlSelector = '.' + owl_containers[ i ].className;
		owlSelector = owlSelector.replaceAll( ' ', '.' );

		owl = $( owlSelector );

		//To do: add support for data dots : data-dot="<button role='button' class='owl-dot'></button>"

		owl.owlCarousel( {
			items: 1,
			animateIn: 'faceIn',
			animateOut: 'fadeOut',
			mouseDrag: false,
			loop: false,
			margin: 0,
			nav: true,
			navText: [
				'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path stroke="none" d="M0 0h24v24H0z"></path><polyline points="15 6 9 12 15 18"></polyline></svg><span class="screen-reader-text">Previous slide</span>',
				'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path stroke="none" d="M0 0h24v24H0z"></path><polyline points="9 6 15 12 9 18"></polyline></svg><span class="screen-reader-text">Next slide</span>',
			],
			dots: true,
			addClassActive: true, // visible items have class active
			onChanged( event ) {
				let activeSlide =
					event.currentTarget.children[ 0 ].children[ 0 ].children[
						event.item.index
					];

				if ( activeSlide === undefined ) {
					activeSlide = event.currentTarget;
				}

				//console.log('active slide : ', activeSlide);
			},
		} );

		/*keyboard navigation*/
		$( document.documentElement ).keyup( function ( event ) {
			if ( event.keyCode === 37 ) {
				/*left key*/
				owl.trigger( 'prev.owl.carousel', [ 700 ] );
			} else if ( event.keyCode === 39 ) {
				/*right key*/
				owl.trigger( 'next.owl.carousel', [ 700 ] );
			}
		} );
	}
} );
